import { S142gComponentsMap } from "./s142g/";
import { S101gComponentsMap } from "./s101g/";
import { S143gComponentsMap } from "./s143g/";
import { S129gComponentsMap } from "./s129g/";
import { S121gComponentsMap } from "./s121g/";
import { MapsetComponentsMap } from "./mapset/";
import { S102gComponentsMap } from "./s102g/";
import { S145gComponentsMap } from "./s145g/";
import { S126gComponentsMap } from "./s126g/";
import { S127gComponentsMap } from "./s127g/";
import { S141gComponentsMap } from "./s141g/";
import { S123gComponentsMap } from "./s123g/";
import { S128gComponentsMap } from "./s128g/";
import { S146gComponentsMap } from "./s146g/";
import { S1dbgComponentsMap } from "./s1dbg/";
import { S125gComponentsMap } from "./s125g/";
import { S124gComponentsMap } from "./s124g/";
import { S140gComponentsMap } from "./s140g/";
import { S110gComponentsMap } from "./s110g/";
import { S144gComponentsMap } from "./s144g/";
import { S999gComponentsMap } from "./s999g/";
import { S122gComponentsMap } from "./s122g/";
import { UtilityComponentsMap, UtilitySubComponentsMap } from "./utility/";

export const mapSubComponents = {
    ...UtilitySubComponentsMap
};

export const mapComponents = {
    ...S142gComponentsMap,
    ...S101gComponentsMap,
    ...S143gComponentsMap,
    ...S129gComponentsMap,
    ...S121gComponentsMap,
    ...MapsetComponentsMap,
    ...S102gComponentsMap,
    ...S145gComponentsMap,
    ...S126gComponentsMap,
    ...S127gComponentsMap,
    ...S141gComponentsMap,
    ...S123gComponentsMap,
    ...S128gComponentsMap,
    ...S146gComponentsMap,
    ...S1dbgComponentsMap,
    ...S125gComponentsMap,
    ...S124gComponentsMap,
    ...S140gComponentsMap,
    ...S110gComponentsMap,
    ...S144gComponentsMap,
    ...S999gComponentsMap,
    ...S122gComponentsMap,
    ...UtilityComponentsMap
};